<template>
    <div id="DmhTransactionCancelled">

        <div class="gp-select-container mb-5 pb-5" ref="gpSelectTop">
            <div class="d-flex flex-column align-items-center justify-content-center">
                <h3 class="dmh-start-title brand-text pb-5 mb-3">Failed to book</h3>
                <div class="brand-text pb-5 mb-0">Your transaction was cancelled.</div>
                    <b-button variant="cta" size="lg" id="return-to-home-button" class="py-4 px-5 w-100" squared
                        @click="redirectHandler()">Return to 'My Health'</b-button>
            </div>
        </div>
    </div>
</template>
  
<script>


import { redirectHandler } from "@/utils/RedirectHandler";

export default {
    name: "DmhTransactionCancelled",
    props: [],
    components: {
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
      redirectHandler



    },
    watch: {
        // selectedView: function (view) {
        //     let self = this;
        //     let day = moment().day();
        //     let width = window.innerWidth;
        //     if (view === 'appointmentSelect') {
        //         this.$nextTick(() => {
        //             if(width < 786){
        //                     self.$refs.slickRef.goTo(day, true);
        //             }
        //         });            
        //     }
        // }
    },
    computed: {


    },
};
</script>
<style lang="less">
#DmhTransactionCancelled {
    width: 100%;
    max-width: 100%;
    font-size: 1.6rem;
    max-width: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    b {
      font-family: "PlusJakartaSansBold";
    }
    .confirm-check{
        font-size: 10rem;
        color: #02b57c;
    }
    .dmh-start-title {
        text-align: center;
        font-size: 2.2rem;
        letter-spacing: 0;
        font-family: "PlusJakartaSansBold";
    }

    .button-group {
        border: 1px solid #0079c8;
        border-radius: 5px;
        background-color: white;
    }

    .date-selector-container {
        min-width: 100%;
        border-radius: 12px;
        padding: 20px;
        width: 500px;
        margin-bottom: 10px;
    }
    .dmh-timeslots-container{
        margin-top: 25px;
        max-width: 500px;
    }

    .date-select-button {
        background-color: white;
        cursor: pointer;
        padding: 10px;
        font-size: 1.8rem !important;
        border: 1px solid white;
        color: #0079c8;
        border-radius: 8px;

        &:hover {
            background-color: #eee;
            border: 1px solid #eee;
        }

        .month-class {
            font-size: 1.4rem;
            color: #ccc;
        }
    }
    .preview-image{
        height: 80px;
        border-radius: 1000px;
        border: 3px solid;
        border-color: inherit;
    }

    .date-select-button:disabled,
    .date-select-button[disabled] {
        cursor: not-allowed;
        background-color: white;
        padding: 10px;
        font-size: 1.8rem !important;
        border: 1px solid white;
        border-radius: 8px;
        color: #ccc;

        &:hover {
            border: 1px solid white;
        }
    }

    .timeslot-button {
        color: #21272A;
        border: 1px solid #0079c8;
    }

    .selected-date {
        background-color: #0079c8;
        color: white;

        &:hover {
            background-color: #0079c8;
            color: white !important;
        }
    }

    .no-appointments {
        font-size: 1.6rem;
    }

    .no-appointments-text {
        padding-top: 25px;
        font-size: 1.6rem;
    }

 
}
</style>
  